import { render, staticRenderFns } from "./ProductListCateCascade.vue?vue&type=template&id=84989a3c&scoped=true&"
import script from "./ProductListCateCascade.vue?vue&type=script&lang=ts&"
export * from "./ProductListCateCascade.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListCateCascade.vue?vue&type=style&index=0&id=84989a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84989a3c",
  null
  
)

export default component.exports